import { render, staticRenderFns } from "./TemplatesToolbar.vue?vue&type=template&id=453feb83&"
import script from "./TemplatesToolbar.vue?vue&type=script&lang=js&"
export * from "./TemplatesToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports